export default $(()=>{

    var passwordButton = $('.show-pass');
    var passwordHolder = $('.pass-holder');
    var isClicked = false;

    passwordButton.click(function() {
        if(isClicked == true){
            passwordHolder.attr("type", "password");
            isClicked = false;
            passwordButton.attr("value", "Show Password");
        }
        else if(isClicked == false){
            passwordHolder.attr("type", "text");
            isClicked = true;
            passwordButton.attr("value", "Hide Password");
        }
    });

});